export default __webpack_public_path__ + "static/media/settings-black.cee68f5a.svg";